import { Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';

import { HeaderBreadcrumb } from '@/components/ui';
import { Route } from '@/constants';

import { CustomerDetailsProvider, useCustomerDetailsContext } from './context';
import { CustomerInfo } from './customer-info.component';
import PaymentStatusSummary from './customer-payment-status.component.tsx';
import { CustomerSummary } from './customer-summary.component';
import { AddCustomerPayment } from './make-payment.component';
import { OrderHistory } from './order-history.component';

const CustomerDetailsComponent = () => {
    const { data, isLoading, isError, error } = useCustomerDetailsContext();

    return (
        <SectionContainer
            isError={isError}
            error={error}
            isLoading={isLoading}
            fallbackPath={Route.CUSTOMERS}
        >
            <Card className="grid min-w-0 grid-cols-1 gap-4 overflow-hidden p-3 sm:p-4 lg:grid-cols-[minmax(0,2fr)_minmax(18rem,1fr)]">
                <div className="min-w-0 lg:col-span-2 [&_[aria-current=page]]:break-all">
                    <HeaderBreadcrumb
                        items={[
                            { label: 'Customers', href: Route.CUSTOMERS },
                            { label: data?.name || 'Customer Details' },
                        ]}
                    />
                </div>
                <div className="min-w-0 space-y-4">
                    <CustomerInfo />
                    <PaymentStatusSummary />
                    <OrderHistory />
                </div>
                <div className="min-w-0 space-y-4">
                    <CustomerSummary />
                    <AddCustomerPayment />
                </div>
            </Card>
        </SectionContainer>
    );
};

export const CustomerDetails = () => {
    return (
        <CustomerDetailsProvider>
            <CustomerDetailsComponent />
        </CustomerDetailsProvider>
    );
};

CustomerDetails.displayName = 'CustomerDetails';
